import category from './category'

export default category
